import React, { useState } from 'react';
import { reviews as initialReviews } from '../mock';
import { Star, Plus } from 'lucide-react';
import { toast } from '../hooks/use-toast';

const Reviews = () => {
  const [reviews, setReviews] = useState(initialReviews);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: '', city: '', rating: 5, text: '' });

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.text) return;
    setReviews([{ id: Date.now(), ...form }, ...reviews]);
    setForm({ name: '', city: '', rating: 5, text: '' });
    setShowForm(false);
    toast({ title: 'Review posted!', description: 'Thanks for the crunchy words.' });
  };

  return (
    <section className="px-5 md:px-8 py-16 md:py-24 bg-[#2A9D8F] text-[#FFF4E6]">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
          <div>
            <div className="text-xs font-bold uppercase tracking-widest text-[#FFD84D]">Real crunchers, real words</div>
            <h2 className="font-display text-5xl md:text-7xl uppercase leading-[0.9] mt-2">
              What people<br />are saying.
            </h2>
          </div>
          <button onClick={() => setShowForm(!showForm)} className="btn-chunky primary">
            <Plus size={18} /> Leave a Review
          </button>
        </div>

        {showForm && (
          <form onSubmit={submit} className="bg-[#FFF4E6] text-[#1a1a1a] rounded-3xl crunch-shadow p-6 md:p-8 mb-8 grid md:grid-cols-2 gap-4">
            <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Your Name" className="px-4 py-3 rounded-2xl border-2 border-[#1a1a1a] font-brico" />
            <input value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} placeholder="City" className="px-4 py-3 rounded-2xl border-2 border-[#1a1a1a] font-brico" />
            <div className="flex items-center gap-2 md:col-span-2">
              <span className="font-brico font-bold">Rating:</span>
              {[1, 2, 3, 4, 5].map((n) => (
                <button type="button" key={n} onClick={() => setForm({ ...form, rating: n })}>
                  <Star size={22} className={n <= form.rating ? 'fill-[#FFD84D] text-[#FFD84D]' : 'text-[#1a1a1a]'} />
                </button>
              ))}
            </div>
            <textarea required value={form.text} onChange={(e) => setForm({ ...form, text: e.target.value })} placeholder="How was the crunch?" rows={3} className="md:col-span-2 px-4 py-3 rounded-2xl border-2 border-[#1a1a1a] font-brico" />
            <button type="submit" className="btn-chunky primary md:col-span-2 justify-center">Post Review</button>
          </form>
        )}

        <div className="grid md:grid-cols-3 gap-5">
          {reviews.map((r) => (
            <div key={r.id} className="bg-[#FFF4E6] text-[#1a1a1a] rounded-3xl crunch-shadow p-6">
              <div className="flex items-center gap-1">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={16} className={i < r.rating ? 'fill-[#E63946] text-[#E63946]' : 'text-black/20'} />
                ))}
              </div>
              <p className="font-brico mt-3 text-lg leading-snug">“{r.text}”</p>
              <div className="mt-4 flex items-center justify-between">
                <div className="font-display uppercase">{r.name}</div>
                <div className="text-xs uppercase font-bold opacity-60">{r.city}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
